<template>
  <transition tag="tbody" name="fade">
    <tr>
      <td class="text-center pt-4" scope="row">
        {{ sn }}
      </td>
      <td class="">
        <select
          class="form-control border border-dark py-0 px-2 rounded-0 mb-2"
          @change="fetchGrades(item.name)"
          v-model="item.name"
        >
          <option value disabled selected>
            Choose Commodity
          </option>
          <option v-for="product in products" :key="product.id">
            {{ product.name }}
          </option>
        </select>
        <select
          class="form-control border border-dark py-0 px-2 rounded-0"
          @change="fetchPrice(item.grade)"
          v-model="item.grade"
        >
          <option value disabled selected>Choose Grade</option>
          <option value="export">Export Grade</option>
          <option
            :value="grade.name"
            v-for="(grade, index) in grades"
            :key="index"
          >
            {{ grade.name | capitalize }}
          </option>
        </select>
      </td>
      <!-- <td class="">
        
      </td> -->
      <td class="">
        <!-- <div class="input-group"> -->
        <select
          class="small form-control border border-dark px-2 py-0 rounded-0 mb-2"
          v-model="item.weight"
          @change="notifyParent('weight')"
        >
          <option value="kg">Kg</option>
          <option value="tonne">Tonne</option>
        </select>
        <select
          class="form-control border border-dark py-0 px-2 rounded-0"
          v-model.number="item.qty"
          @change="notifyParent()"
        >
          <option value disabled selected>Choose Qty</option>
          <option v-if="item.weight == 'tonne'" value="1">1 tonne</option>
          <option v-if="item.weight == 'tonne'" value="15">15 tonnes</option>
          <option v-for="weight in weightRange" :key="weight" :value="weight"
            >{{ weight }} {{ item.weight }}</option
          >
        </select>
        <!-- </div> -->
      </td>
      <td class="pt-4">
        <div class="w-100">
          {{ price | currency("₦", 0) | placeholder("₦ 0") }}
        </div>
      </td>
      <td>
        <div v-if="isMultipleExpected" class="mb-2">
          <div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
            <label
              class="btn btn-secondary"
              :class="{ active: type == 'single' }"
            >
              <input type="radio" v-model="type" value="single" />
              Single
            </label>
            <label
              class="btn btn-secondary"
              :class="{ active: type == 'multiple' }"
            >
              <input type="radio" v-model="type" value="multiple" />
              Multiple
            </label>
          </div>
        </div>
        <div v-else>
          <input
            type="date"
            v-model="item.date"
            @change="notifyParent()"
            class="form-control border border-dark py-0 px-2 rounded-0"
            placeholder="Pick a single or multiple delivery dates"
          />
        </div>
        <div class="input-dates mb-1" v-for="i in dateLength" :key="i">
          <input
            type="date"
            v-model="item.date"
            @change="notifyParent()"
            class="form-control border border-dark py-0 px-2 rounded-0"
            placeholder="Pick a single or multiple delivery dates"
          />
        </div>
      </td>
      <td>
        <textarea
          type="text"
          class="form-control border border-dark py-0 px-2 rounded-0"
          name="Address"
          rows="3"
          @input="notifyParent()"
          v-model="item.address"
          placeholder="Do give us an address to deliver to"
        />
      </td>
      <td class="pt-4 text-center">
        <span @click="deleteRow()" class="delete-btn"></span>
      </td>
    </tr>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { weightMixin } from "@/_mixins";

export default {
  name: "InventoryItem",
  mixins: [weightMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    serial: {
      type: Number,
      required: true
    }
  },

  created() {
    this.fetchGrades(this.item.name);
    this.fetchPrice(this.item.grade);
  },

  computed: {
    ...mapGetters("cart", ["products"]),
    sn() {
      return this.serial + 1;
    },
    weightRange() {
      return this.item.weight == "kg"
        ? this.range(100, 900, 100)
        : this.range(30, 600, 30);
    },
    isFormFilled() {
      return (
        this.item.name &&
        this.item.grade &&
        this.item.weight &&
        this.item.qty &&
        this.item.date &&
        this.item.price &&
        this.item.address
      );
    },
    isMultipleExpected() {
      return this.item.weight == "tonne" && this.item.qty > 30;
    },
    dateLength() {
      if (this.isMultipleExpected) {
        return this.item.qty / 30;
      }
      return 1;
    }
  },

  data() {
    return {
      grades: [],
      price: this.item.price,
      type: "single"
    };
  },

  methods: {
    ...mapActions("cart", ["deleteCartItem"]),

    fetchGrades(productName) {
      let product = this.products.find(item => item.name === productName);
      this.grades = product ? product.grades : [];
      this.item.weight = "kg";
      this.notifyParent();
    },
    fetchPrice(gradeName) {
      let grade = this.grades.find(g => g.name === gradeName);
      this.price = this.item.price = grade ? grade.price : 0;
      this.notifyParent();
    },
    notifyParent(action) {
      switch (action) {
        case "weight":
          this.resetWeight();
          break;

        default:
          break;
      }
      this.isFormFilled && this.$emit("valid", true);
    },
    resetWeight() {
      this.$emit("resetWeight");
    },
    deleteRow() {
      this.$emit("remove", this.serial);
    },
    setType(type) {
      this.type = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-secondary:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-group.btn-group-toggle .btn-secondary {
  color: black;
  background-color: white;
  border-color: black;
  outline: none;
  // border-radius: 0;
}
</style>
